/** @file Mounts the export dialog for the open project and binds export.open (Mod+Shift+E, rebindable). */
import { useEffect } from 'react';
import { useStore } from 'zustand';
import { projectsApi } from '../../api/projectsApi';
import { useT } from '../../shell/i18n/useT';
import { registerEffective } from '../../shell/shortcuts/registerEffective';
import { currentDoc } from '../../stores/currentDoc';
import { docStore } from '../../stores/docStore';
import { Dialog } from '../../ui-kit/Dialog';
import { bindings } from './bindings';
import { exportDialogStore } from './exportDialogStore';
import { ExportPanel } from './ExportPanel';
import './export.css';

const show = (): void => { exportDialogStore.setState({ open: true }); };
const hide = (): void => { exportDialogStore.setState({ open: false }); };

/** Rendered by EditorFrame once the document is in; Dialog mounts only while open (R-E7-10). */
export function ExportDialogHost({ projectId }: { projectId: string }) {
  const t = useT();
  const open = useStore(exportDialogStore, (s) => s.open);
  const doc = useStore(docStore, (s) => (s.projectId === projectId ? currentDoc(s) : null));
  useEffect(() => {
    const unregister = registerEffective('global', bindings, { 'export.open': show });
    return () => { unregister(); hide(); };
  }, []);
  if (!open || doc === null) return null;
  return (
    <Dialog open title={t('exportDialog.title')} closeLabel={t('exportDialog.close')} onClose={hide}>
      <ExportPanel t={t} projectId={projectId} doc={doc} client={projectsApi} />
    </Dialog>
  );
}
